import React from "react";
import ReactDOM from "react-dom/client";
import "@unicef/shared-resources/assets/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

if ("caches" in window) {
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      caches.delete(cacheName);
    });
  });
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

const disableCacheHeaders = () => {
  try {
    const meta1 = document.createElement("meta");
    meta1.httpEquiv = "Cache-Control";
    meta1.content = "no-store, no-cache, must-revalidate, private";
    document.head.appendChild(meta1);

    const meta2 = document.createElement("meta");
    meta2.httpEquiv = "Pragma";
    meta2.content = "no-cache";
    document.head.appendChild(meta2);

    const meta3 = document.createElement("meta");
    meta3.httpEquiv = "Expires";
    meta3.content = "0";
    document.head.appendChild(meta3);
  } catch (e) {
    console.warn("Could not inject cache prevention meta tags", e);
  }
};
disableCacheHeaders();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

reportWebVitals();
